import { options } from './Options'

export const IDDocOptions: options[] = [
  { label: '', value: '' },
  { label: 'Identity Card - Pink', value: 'ic-pink' },
  { label: 'Identity Card - Blue', value: 'ic-blue' },
  { label: 'Other', value: 'others' }
]
